export default __webpack_public_path__ + "static/media/photo-6.f81faa1f.png";